import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReports from '../reducers/reports.reducer';

export const selectReportsState = createFeatureSelector<fromReports.State>(
  fromReports.reportsFeatureKey
);

export const selectReportsFilterTypeState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.filterType
);

export const selectReportsIsLoadingState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.isLoading
);

export const selectReportsIsMaster = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.isMasterChecked
);


export const selectReportListState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.reports
);

export const selectReportsFilterIDState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.filterID
);

export const selectReportsQueryState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.query
);

export const selectReportsSelectedState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.selected
);

export const selectReportsPickedSelectedState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.pickedSelected
);
export const selectReportsProductSerialNumberSelectedState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.productSerialNumberSelected
);
export const selectReportsReceivedSelectedState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.receivedSelected
);
export const selectReportsReorderSelectedState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.reorderSelected
);

export const selectReportsBarcodeState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.barcodes
);

export const selectReportState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.report
);

export const selectReportsDuplicateBarcodeState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.duplicateBarcode
);

export const selectReportsSortState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.sortType
);

export const selectReportsDirectionState = createSelector(
  selectReportsState,
  (state: fromReports.State) => state.direction
);

export const selectReportPageState = createSelector(
  selectReportsState,
  (state: fromReports.State) => {
    state.direction
  }
);
